// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","dark":"App_dark__sU4Z9","loading":"App_loading__KwtXr","app2":"App_app2__AqsTY"};